import StackKit from "@/shared/components/kit/stack";
import React, { SetStateAction } from "react";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Switch } from "@mui/material";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";

interface AllUserContentModalProps {
  setSelectedSwitch: React.Dispatch<SetStateAction<boolean>>;
  selectedSwitch: boolean;
  countUser: number | string;
}
/**
 * AllUserContentModal
 *
 * نمایش مودال جهت مشخص کردن امکان نقد شوندگی مبلغ برای تمام کاربران سازمان.
 *
 * @param setSelectedSwitch - تابع برای تغییر وضعیت سوییچ
 * @param selectedSwitch - وضعیت فعلی سوییچ (true/false)
 * @param countUser - تعداد کاربران که شارژ خواهند شد
 *
 * @returns JSX.Element
 */
const AllUserContentModal = ({setSelectedSwitch,selectedSwitch,countUser,}: AllUserContentModalProps) => {
  return (
    <StackKit gap={4} sx={{ width: "100%" }}>
      {/* Header */}
      <StackKit sx={{ textAlign: "center", px: { xs: 1, sm: 2 } }}>
        <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "14px", sm: "16px" } }}>
          شما در حال شارژ همه کاربران این سازمان به تعداد {toPersianNumber(countUser)} نفر هستید
        </TypoGraphyKit>
      </StackKit>

      {/* Description */}
      <StackKit sx={{ px: { xs: 1, sm: 2 } }}>
        <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "12px", sm: "14px" }, lineHeight: 1.6 }}>
          پذیرنده گرامی؛ لطفا در ابتدا مشخص کنید که کاربر امکان نقد کردن مبلغی که
          در مرحله بعد وارد میکنید را دارد یا ندارد. توجه داشته باشید که اگر به
          کاربر امکان نقد شوندگی مبلغ را بدهید، مبلغ مورد نظر مستقیما از کیف پول نقدی شما
          کسر شده و به کیف پول کاربر منتقل میشود. همچنین در صورتی که امکان نقد شوندگی
          را به کاربر ندهید، مبلغ وارد شده از موجودی اعتبار داخلی نقدی شما کسر می‌گردد.
        </TypoGraphyKit>
      </StackKit>

      {/* Switch Control */}
      <StackKit direction={{ xs: "column", sm: "row" }} justifyContent={{ xs: "center", sm: "space-between" }} alignItems={{ xs: "flex-start", sm: "center" }} gap={2} sx={{ px: { xs: 1, sm: 2 } }}>
        <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
          امکان نقد شوندگی توسط کاربر:
        </TypoGraphyKit>

        <StackKit direction={"row"} gap={1} alignItems={"center"}>
          <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
            دارد
          </TypoGraphyKit>
          <Switch checked={selectedSwitch} defaultChecked onChange={(event, checked) => setSelectedSwitch(checked)}/>
          <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
            ندارد
          </TypoGraphyKit>
        </StackKit>
      </StackKit>
    </StackKit>
  );
};

export default AllUserContentModal;
